// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useState} from 'react';
// @ts-ignore
import {Input} from '../input';
// @ts-ignore
import {strftime} from '/util/date.js';

interface i_timeinput_props {
    date: Date;
    on_change: (value:Date)=>void;
    no_margin?: boolean;
}
export const Time_input = ({date, on_change, no_margin}:i_timeinput_props)=>{
    const [time_str, set_time_str] = useState(strftime('%H:%M:%S', date, {
        local: true
    }));
    const to_raw_string = formatted=>{
        return (formatted||'').replace(/[^\d]+/g, '');
    };
    const from_raw_string = raw=>{
        const template = '__:__:__';
        let result = '';
        for (let i=0, j=0; i<template.length; ++i){
            while (i < template.length && template[i] !== '_'){
                result += template[i];
                ++i;
            }
            if (j < raw.length)
                result += raw[j++];
            else
                result += template[i];
        }
        return result;
    };

    const on_input = e=>{
        const input_type = e.nativeEvent.inputType;
        let pos = e.target.selectionStart;
        let value = e.target.value;
        if (pos == e.target.selectionEnd)
        {
            if (input_type == 'deleteContentBackward' && pos % 3 == 2)
            {
                value = value.slice(0, pos - 1) + value.slice(pos);
                pos--;
            }
            if (input_type == 'insertText' && pos % 3 == 0)
                pos++;
            if (input_type == 'deleteContentForward' && pos % 3 == 2)
                value = value.slice(0, pos) + value.slice(pos + 1);
        }
        const raw = to_raw_string(value);

        if (raw.length >= 2)
        {
            const s = (raw + '0000').substr(0, 6);
            date.setHours(+s.substr(0, 2));
            date.setMinutes(+s.substr(2, 2));
            date.setSeconds(+s.substr(4, 2));
        }

        e.target.value = from_raw_string(raw);
        set_time_str(from_raw_string(raw));
        e.target.selectionStart = e.target.selectionEnd = pos;
    };

    const prop_time_str = strftime('%H:%M:%S', date, {local: true});
    if (to_raw_string(time_str).length == 6 && time_str !== prop_time_str)
        set_time_str(prop_time_str);

    const emit_changed = ()=>{
        const raw = to_raw_string(time_str);
        if (raw.length >= 2)
            on_change(date);
        set_time_str(strftime('%H:%M:%S', date, {local: true}));
    };

    return <Input type="text" onInput={on_input} value={time_str}
      no_margin={no_margin}
      on_change={()=>{
        // XXX dmitriiz: change interface and remove this fn
        console.log('on change event');
      }} on_blur={emit_changed} />;
};
